import type { ReactNode } from 'react';
import { AlertTriangle, Info, StickyNote, type LucideIcon } from 'lucide-react';
import { cx } from './cx';

export type CalloutTone = 'info' | 'warn' | 'note';

const tones: Record<CalloutTone, { box: string; icon: string; Icon: LucideIcon }> = {
  info: { box: 'bg-surface-indigo text-primary-900', icon: 'text-primary', Icon: Info },
  warn: { box: 'bg-warn-soft text-warn-fg', icon: 'text-warn-line', Icon: AlertTriangle },
  // Encart en pointillés jaunes (landing) : notes, astuces, zone à compléter.
  note: { box: 'border border-dashed border-note-line bg-note-bg text-body', icon: 'text-warn-line', Icon: StickyNote },
};

interface CalloutProps {
  tone?: CalloutTone;
  icon?: LucideIcon;
  children: ReactNode;
  className?: string;
}

/** Encart d'explication dans un bloc. */
export function Callout({ tone = 'info', icon, children, className }: CalloutProps) {
  const t = tones[tone];
  const Icon = icon ?? t.Icon;
  return (
    <div className={cx('flex items-start gap-2.5 rounded-[14px] px-3.5 py-3 text-[12.5px] leading-normal', t.box, className)}>
      <Icon size={16} strokeWidth={1.9} className={cx('mt-px shrink-0', t.icon)} aria-hidden />
      <div className="min-w-0">{children}</div>
    </div>
  );
}
